var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContractVoided(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0499 19.4628L19.6199 18.0328C19.6599 17.8328 19.6699 17.6328 19.6699 17.4328V9.59281C19.6699 9.35281 19.4799 9.15281 19.2399 9.15281H16.2699C14.5099 9.14281 13.0499 7.68281 13.0499 5.90281V2.76281C13.0499 2.51281 12.8599 2.31281 12.6099 2.31281H7.44992C6.45992 2.31281 5.53992 2.65281 4.80992 3.22281L4.00992 2.41281C3.71992 2.12281 3.23992 2.12281 2.94992 2.41281C2.65992 2.71281 2.65992 3.18281 2.94992 3.47281L19.9899 20.5228C20.1299 20.6728 20.3299 20.7428 20.5199 20.7428C20.7099 20.7428 20.8999 20.6728 21.0499 20.5228C21.3399 20.2328 21.3399 19.7628 21.0499 19.4628Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4 7.73277C17.07 7.73277 18.01 7.74277 18.8 7.73277C19.21 7.73277 19.41 7.24277 19.13 6.95277C18.62 6.41277 17.92 5.67277 17.2 4.92277C16.49 4.17277 15.77 3.42277 15.25 2.87277C14.96 2.56277 14.45 2.77277 14.45 3.19277V5.76277C14.45 6.84277 15.33 7.73277 16.4 7.73277Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09985 6.71276V17.2127C3.09985 19.7427 5.14985 21.8027 7.65985 21.8027H15.3298C16.3898 21.8027 17.3698 21.4127 18.1198 20.7727L3.18985 5.83276C3.12985 6.11276 3.09985 6.41276 3.09985 6.71276Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractVoided);
export default __webpack_public_path__ + "static/media/CONTRACT_VOIDED.6ef5aaa31ab1bb08f56a4504c3c173f0.svg";
export { ForwardRef as ReactComponent };